var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUserLock = function SvgUserLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 76,
    height: 40,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#AABCBF",
    d: "M27 12a5 5 0 1 1 10 0 5 5 0 0 1-10 0m13 0a8 8 0 1 0-16 0 8 8 0 0 0 16 0M21.081 33a8.15 8.15 0 0 1 8.063-7h5.712A8.14 8.14 0 0 1 42 30.231V26q0-.196.019-.394A11.1 11.1 0 0 0 34.856 23h-5.712C22.988 23 18 27.988 18 34.144c0 1.025.831 1.856 1.856 1.856h22.682A4 4 0 0 1 42 34v-1zM51 19c1.106 0 2 .894 2 2v3h-4v-3c0-1.106.894-2 2-2m-5 2v3c-1.106 0-2 .894-2 2v8c0 1.106.894 2 2 2h10c1.106 0 2-.894 2-2v-8c0-1.106-.894-2-2-2v-3c0-2.762-2.237-5-5-5s-5 2.238-5 5"
  })));
};
export default SvgUserLock;